import type { ReactNode } from "react";

import { Box } from "../../components/ui/box";
import type { NegativeSpacingToken } from "../../components/ui/box-classes";
import { ScrollArea } from "../../components/ui/scroll-area";
import type { Omittable } from "../../lib/props";
import { SCROLLPORT_CONTAINER_CLASS } from "../../lib/scroll-end-slack";
import { WidgetScrollEndGutter } from "./widget-card";

export type WidgetBleedScrollerProps = Omittable<{
  /** The card inset the scroller reclaims on both sides and restores inside,
   *  so a row's hover wash reaches the card edge while its text keeps the
   *  inset. */
  inset: NegativeSpacingToken;
  children: ReactNode;
}>;

/**
 * A body's own scrollport under a header of its own (a `body: "bleed-bottom"`
 * module): it grows to the body's remaining height, bleeds the card inset on
 * both sides so a row's wash reaches the edge, restores that inset around the
 * rows, fades at the edges while content continues, and ends on the kit's
 * scroll-end slack like every other widget scrollport (the ScrollArea root
 * is the size container its half-height measures).
 */
export function WidgetBleedScroller({ inset, children }: WidgetBleedScrollerProps) {
  return (
    <Box grow minHeight={0} overflow="hidden" marginXNegative={inset}>
      <ScrollArea fill scrollFade className={SCROLLPORT_CONTAINER_CLASS}>
        <Box direction="column" paddingX={inset}>
          {children}
          <WidgetScrollEndGutter />
        </Box>
      </ScrollArea>
    </Box>
  );
}
